// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IjlaHThVT4UdED {
  width: calc(100vw - 48px);
  min-width: 375px;
  max-width: 600px;
  padding: var(--ds-space-300, 24px);
  border-radius: var(--ds-border-radius-200, 8px);
  background-color: var(--ds-surface, #ffffff);
}
`, ""]);
// Exports
export var PremiumTrialPaymentModal = `IjlaHThVT4UdED`;
export default ___CSS_LOADER_EXPORT___;
